/*----------------------------------
- DEPENDANCES
----------------------------------*/

// Npm
import React from 'react';
import { useErrorBoundary } from 'preact/hooks';

// Core
import RouterComponent from '@client/services/router/components/router';

// Resources
import IllustrationImg from '@/client/assets/illustration/login.jpg';

// Resources
import Screenshot from './screenshot.jpg';

/*----------------------------------
- TYPES
----------------------------------*/

/*----------------------------------
- LAYOUT
----------------------------------*/
import './index.less';
export default ({ data, user, api, Router, toast, modal, context, app, request, page }) => {
    /*----------------------------------
    - INIT
    ----------------------------------*/

    /*----------------------------------
    - ACTIONS
    ----------------------------------*/

    /*----------------------------------
    - RENDER
    ----------------------------------*/
    return (
        <>
            <RouterComponent service={Router} />
        </>
    );
};
